import * as React from 'react';

export interface IFileAccessTokenContext {
	items: { name: string; token: string }[];
}

export const FileAccessTokenContext = React.createContext<IFileAccessTokenContext>({
	items: []
});

export function appendAccessToken(url: string, tokens: { name: string; token: string }[]) {
	try {
		let faToken = '';
		const parsed = new URL(url);
		// Should be good enough check for a blob storage URL
		const isBlobStorage =
			parsed.hostname.indexOf('core.windows.net') >= 0 || (parsed.hostname === '127.0.0.1' && parsed.port === '10000');
		if (isBlobStorage) {
			for (const token of tokens) {
				//Token name is the container name, so if the part is in the URL, append
				//its associated token value
				const part = `/${token.name}/`;
				if (url.indexOf(part) >= 0) {
					faToken = token.token ?? '';
					break;
				}
			}
		}
		return url + faToken;
	} catch {
		return url;
	}
}

const SECONDS = 1000;

export const FileAccessTokenContextProvider = ({ children, clientQuery }: { children: React.ReactNode; clientQuery: any }) => {
	const [tokens, setTokens] = React.useState([]);
	const fetchTokens = async () => {
		const res = await clientQuery();
		setTokens(res?.data?.me?.fileAccessTokens);
	};
	const intervalLoop = () => {
		fetchTokens();
		setTimeout(intervalLoop, 4 * 60 * 60 * SECONDS);
	};
	React.useEffect(() => {
		intervalLoop();
	}, []);
	return <FileAccessTokenContext.Provider value={{ items: tokens }}>{children}</FileAccessTokenContext.Provider>;
};
